module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_CJEnM.bea901d46ff28f9bca9cc64ad2c8aa43.png";